
import { Component, Prop } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'

/** 对应后端 LEVEL_SCORE_TYPE（src/common/contants/index.contants.ts） */
const SCORE_TYPE_NAME = {
  1: '完成购买商品任务',
  2: '后台新增积分',
  3: '后台减少积分',
  4: '完成任务',
}
/** 对应后端 TASK_TYPE */
const TASK_TYPE_NAME = {
  1: '首次注册',
  2: '绑定手机号',
  3: '消费满额',
  4: '完成订单数',
}
/** 记为减少的方向：后台减少积分，其余为增加 */
const REDUCE_TYPES = [3]

@Component({})
export default class extends ListViewVue {

  @Prop()
  userId: any;

  typeList = Object.keys(SCORE_TYPE_NAME).map((key) => {
    return { name: SCORE_TYPE_NAME[key], value: Number(key) }
  });

  getTypeName(type) {
    return SCORE_TYPE_NAME[type] || "-";
  }

  getTaskName(taskType) {
    return TASK_TYPE_NAME[taskType] || "-";
  }

  isReduce(type) {
    return REDUCE_TYPES.indexOf(Number(type)) > -1;
  }

  getValue(row) {
    return `${this.isReduce(row.type) ? '-' : '+'}${row.amount}`;
  }

  getCondition() {
    return {
      type: "",
      startTime: "",
      endTime: "",
    }
  }

  resetFilter() {
    this.find(this.getCondition())
  }

  async getList() {
    let data: any = { ...this.mesureData, id: this.userId };
    // 空字符串会让后端匹配 type='' / 转出非法日期，直接不传这几个字段
    ['type', 'startTime', 'endTime'].forEach((key) => {
      if (data[key] === '' || data[key] === null || data[key] === undefined) {
        delete data[key];
      }
    });
    return this.$post("/manager/user/score-log-list", data);
  }
}
